var Fe = Object.defineProperty, Ne = Object.defineProperties;
var Ae = Object.getOwnPropertyDescriptors;
var j = Object.getOwnPropertySymbols;
var fe = Object.prototype.hasOwnProperty, de = Object.prototype.propertyIsEnumerable;
var ce = (e, t, r) => t in e ? Fe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, b = (e, t) => {
  for (var r in t || (t = {}))
    fe.call(t, r) && ce(e, r, t[r]);
  if (j)
    for (var r of j(t))
      de.call(t, r) && ce(e, r, t[r]);
  return e;
}, B = (e, t) => Ne(e, Ae(t));
var W = (e, t) => {
  var r = {};
  for (var i in e)
    fe.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && j)
    for (var i of j(e))
      t.indexOf(i) < 0 && de.call(e, i) && (r[i] = e[i]);
  return r;
};
var U = (e, t, r) => new Promise((i, n) => {
  var a = (l) => {
    try {
      s(r.next(l));
    } catch (o) {
      n(o);
    }
  }, c = (l) => {
    try {
      s(r.throw(l));
    } catch (o) {
      n(o);
    }
  }, s = (l) => l.done ? i(l.value) : Promise.resolve(l.value).then(a, c);
  s((r = r.apply(e, t)).next());
});
import * as u from "react";
var H = {}, he;
function Me() {
  if (he) return H;
  he = 1, Object.defineProperty(H, "__esModule", { value: !0 }), H.parse = c, H.serialize = o;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, t = /^[\u0021-\u003A\u003C-\u007E]*$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, i = /^[\u0020-\u003A\u003D-\u007E]*$/, n = Object.prototype.toString, a = /* @__PURE__ */ (() => {
    const f = function() {
    };
    return f.prototype = /* @__PURE__ */ Object.create(null), f;
  })();
  function c(f, g) {
    const h = new a(), w = f.length;
    if (w < 2)
      return h;
    const y = (g == null ? void 0 : g.decode) || d;
    let p = 0;
    do {
      const v = f.indexOf("=", p);
      if (v === -1)
        break;
      const x = f.indexOf(";", p), E = x === -1 ? w : x;
      if (v > E) {
        p = f.lastIndexOf(";", v - 1) + 1;
        continue;
      }
      const C = s(f, p, v), S = l(f, v, C), k = f.slice(C, S);
      if (h[k] === void 0) {
        let F = s(f, v + 1, E), N = l(f, E, F);
        const M = y(f.slice(F, N));
        h[k] = M;
      }
      p = E + 1;
    } while (p < w);
    return h;
  }
  function s(f, g, h) {
    do {
      const w = f.charCodeAt(g);
      if (w !== 32 && w !== 9)
        return g;
    } while (++g < h);
    return h;
  }
  function l(f, g, h) {
    for (; g > h; ) {
      const w = f.charCodeAt(--g);
      if (w !== 32 && w !== 9)
        return g + 1;
    }
    return h;
  }
  function o(f, g, h) {
    const w = (h == null ? void 0 : h.encode) || encodeURIComponent;
    if (!e.test(f))
      throw new TypeError(`argument name is invalid: ${f}`);
    const y = w(g);
    if (!t.test(y))
      throw new TypeError(`argument val is invalid: ${g}`);
    let p = f + "=" + y;
    if (!h)
      return p;
    if (h.maxAge !== void 0) {
      if (!Number.isInteger(h.maxAge))
        throw new TypeError(`option maxAge is invalid: ${h.maxAge}`);
      p += "; Max-Age=" + h.maxAge;
    }
    if (h.domain) {
      if (!r.test(h.domain))
        throw new TypeError(`option domain is invalid: ${h.domain}`);
      p += "; Domain=" + h.domain;
    }
    if (h.path) {
      if (!i.test(h.path))
        throw new TypeError(`option path is invalid: ${h.path}`);
      p += "; Path=" + h.path;
    }
    if (h.expires) {
      if (!m(h.expires) || !Number.isFinite(h.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${h.expires}`);
      p += "; Expires=" + h.expires.toUTCString();
    }
    if (h.httpOnly && (p += "; HttpOnly"), h.secure && (p += "; Secure"), h.partitioned && (p += "; Partitioned"), h.priority)
      switch (typeof h.priority == "string" ? h.priority.toLowerCase() : void 0) {
        case "low":
          p += "; Priority=Low";
          break;
        case "medium":
          p += "; Priority=Medium";
          break;
        case "high":
          p += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${h.priority}`);
      }
    if (h.sameSite)
      switch (typeof h.sameSite == "string" ? h.sameSite.toLowerCase() : h.sameSite) {
        case !0:
        case "strict":
          p += "; SameSite=Strict";
          break;
        case "lax":
          p += "; SameSite=Lax";
          break;
        case "none":
          p += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${h.sameSite}`);
      }
    return p;
  }
  function d(f) {
    if (f.indexOf("%") === -1)
      return f;
    try {
      return decodeURIComponent(f);
    } catch (g) {
      return f;
    }
  }
  function m(f) {
    return n.call(f) === "[object Date]";
  }
  return H;
}
Me();
/**
 * react-router v7.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function R(e, t) {
  if (e === !1 || e === null || typeof e == "undefined")
    throw new Error(t);
}
function $(e, t) {
  if (!e) {
    typeof console != "undefined" && console.warn(t);
    try {
      throw new Error(t);
    } catch (r) {
    }
  }
}
function te({
  pathname: e = "/",
  search: t = "",
  hash: r = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), r && r !== "#" && (e += r.charAt(0) === "#" ? r : "#" + r), e;
}
function re(e) {
  let t = {};
  if (e) {
    let r = e.indexOf("#");
    r >= 0 && (t.hash = e.substring(r), e = e.substring(0, r));
    let i = e.indexOf("?");
    i >= 0 && (t.search = e.substring(i), e = e.substring(0, i)), e && (t.pathname = e);
  }
  return t;
}
function ye(e, t, r = "/") {
  return Oe(e, t, r, !1);
}
function Oe(e, t, r, i) {
  let n = typeof t == "string" ? re(t) : t, a = D(n.pathname || "/", r);
  if (a == null)
    return null;
  let c = ve(e);
  Be(c);
  let s = null;
  for (let l = 0; s == null && l < c.length; ++l) {
    let o = Ye(a);
    s = Ke(
      c[l],
      o,
      i
    );
  }
  return s;
}
function ve(e, t = [], r = [], i = "") {
  let n = (a, c, s) => {
    let l = {
      relativePath: s === void 0 ? a.path || "" : s,
      caseSensitive: a.caseSensitive === !0,
      childrenIndex: c,
      route: a
    };
    l.relativePath.startsWith("/") && (R(
      l.relativePath.startsWith(i),
      `Absolute route path "${l.relativePath}" nested under path "${i}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), l.relativePath = l.relativePath.slice(i.length));
    let o = L([i, l.relativePath]), d = r.concat(l);
    a.children && a.children.length > 0 && (R(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      a.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${o}".`
    ), ve(a.children, t, d, o)), !(a.path == null && !a.index) && t.push({
      path: o,
      score: je(o, a.index),
      routesMeta: d
    });
  };
  return e.forEach((a, c) => {
    var s;
    if (a.path === "" || !((s = a.path) != null && s.includes("?")))
      n(a, c);
    else
      for (let l of we(a.path))
        n(a, c, l);
  }), t;
}
function we(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [r, ...i] = t, n = r.endsWith("?"), a = r.replace(/\?$/, "");
  if (i.length === 0)
    return n ? [a, ""] : [a];
  let c = we(i.join("/")), s = [];
  return s.push(
    ...c.map(
      (l) => l === "" ? a : [a, l].join("/")
    )
  ), n && s.push(...c), s.map(
    (l) => e.startsWith("/") && l === "" ? "/" : l
  );
}
function Be(e) {
  e.sort(
    (t, r) => t.score !== r.score ? r.score - t.score : Je(
      t.routesMeta.map((i) => i.childrenIndex),
      r.routesMeta.map((i) => i.childrenIndex)
    )
  );
}
var We = /^:[\w-]+$/, Ue = 3, _e = 2, He = 1, ze = 10, Ve = -2, me = (e) => e === "*";
function je(e, t) {
  let r = e.split("/"), i = r.length;
  return r.some(me) && (i += Ve), t && (i += _e), r.filter((n) => !me(n)).reduce(
    (n, a) => n + (We.test(a) ? Ue : a === "" ? He : ze),
    i
  );
}
function Je(e, t) {
  return e.length === t.length && e.slice(0, -1).every((i, n) => i === t[n]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function Ke(e, t, r = !1) {
  let { routesMeta: i } = e, n = {}, a = "/", c = [];
  for (let s = 0; s < i.length; ++s) {
    let l = i[s], o = s === i.length - 1, d = a === "/" ? t : t.slice(a.length) || "/", m = Y(
      { path: l.relativePath, caseSensitive: l.caseSensitive, end: o },
      d
    ), f = l.route;
    if (!m && o && r && !i[i.length - 1].route.index && (m = Y(
      {
        path: l.relativePath,
        caseSensitive: l.caseSensitive,
        end: !1
      },
      d
    )), !m)
      return null;
    Object.assign(n, m.params), c.push({
      // TODO: Can this as be avoided?
      params: n,
      pathname: L([a, m.pathname]),
      pathnameBase: Ze(
        L([a, m.pathnameBase])
      ),
      route: f
    }), m.pathnameBase !== "/" && (a = L([a, m.pathnameBase]));
  }
  return c;
}
function Y(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [r, i] = qe(
    e.path,
    e.caseSensitive,
    e.end
  ), n = t.match(r);
  if (!n) return null;
  let a = n[0], c = a.replace(/(.)\/+$/, "$1"), s = n.slice(1);
  return {
    params: i.reduce(
      (o, { paramName: d, isOptional: m }, f) => {
        if (d === "*") {
          let h = s[f] || "";
          c = a.slice(0, a.length - h.length).replace(/(.)\/+$/, "$1");
        }
        const g = s[f];
        return m && !g ? o[d] = void 0 : o[d] = (g || "").replace(/%2F/g, "/"), o;
      },
      {}
    ),
    pathname: a,
    pathnameBase: c,
    pattern: e
  };
}
function qe(e, t = !1, r = !0) {
  $(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let i = [], n = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (c, s, l) => (i.push({ paramName: s, isOptional: l != null }), l ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (i.push({ paramName: "*" }), n += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : r ? n += "\\/*$" : e !== "" && e !== "/" && (n += "(?:(?=\\/|$))"), [new RegExp(n, t ? void 0 : "i"), i];
}
function Ye(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return $(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function D(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let r = t.endsWith("/") ? t.length - 1 : t.length, i = e.charAt(r);
  return i && i !== "/" ? null : e.slice(r) || "/";
}
function Ge(e, t = "/") {
  let {
    pathname: r,
    search: i = "",
    hash: n = ""
  } = typeof e == "string" ? re(e) : e;
  return {
    pathname: r ? r.startsWith("/") ? r : Xe(r, t) : t,
    search: et(i),
    hash: tt(n)
  };
}
function Xe(e, t) {
  let r = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((n) => {
    n === ".." ? r.length > 1 && r.pop() : n !== "." && r.push(n);
  }), r.length > 1 ? r.join("/") : "/";
}
function Z(e, t, r, i) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    i
  )}].  Please separate it out to the \`to.${r}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function Qe(e) {
  return e.filter(
    (t, r) => r === 0 || t.route.path && t.route.path.length > 0
  );
}
function xe(e) {
  let t = Qe(e);
  return t.map(
    (r, i) => i === t.length - 1 ? r.pathname : r.pathnameBase
  );
}
function Ce(e, t, r, i = !1) {
  let n;
  typeof e == "string" ? n = re(e) : (n = b({}, e), R(
    !n.pathname || !n.pathname.includes("?"),
    Z("?", "pathname", "search", n)
  ), R(
    !n.pathname || !n.pathname.includes("#"),
    Z("#", "pathname", "hash", n)
  ), R(
    !n.search || !n.search.includes("#"),
    Z("#", "search", "hash", n)
  ));
  let a = e === "" || n.pathname === "", c = a ? "/" : n.pathname, s;
  if (c == null)
    s = r;
  else {
    let m = t.length - 1;
    if (!i && c.startsWith("..")) {
      let f = c.split("/");
      for (; f[0] === ".."; )
        f.shift(), m -= 1;
      n.pathname = f.join("/");
    }
    s = m >= 0 ? t[m] : "/";
  }
  let l = Ge(n, s), o = c && c !== "/" && c.endsWith("/"), d = (a || c === ".") && r.endsWith("/");
  return !l.pathname.endsWith("/") && (o || d) && (l.pathname += "/"), l;
}
var L = (e) => e.join("/").replace(/\/\/+/g, "/"), Ze = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), et = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, tt = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function rt(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var Ee = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  Ee
);
var nt = [
  "GET",
  ...Ee
];
new Set(nt);
var _ = u.createContext(null);
_.displayName = "DataRouter";
var G = u.createContext(null);
G.displayName = "DataRouterState";
var Re = u.createContext({
  isTransitioning: !1
});
Re.displayName = "ViewTransition";
var at = u.createContext(
  /* @__PURE__ */ new Map()
);
at.displayName = "Fetchers";
var it = u.createContext(null);
it.displayName = "Await";
var I = u.createContext(
  null
);
I.displayName = "Navigation";
var ne = u.createContext(
  null
);
ne.displayName = "Location";
var T = u.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
T.displayName = "Route";
var ae = u.createContext(null);
ae.displayName = "RouteError";
function lt(e, { relative: t } = {}) {
  R(
    X(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: r, navigator: i } = u.useContext(I), { hash: n, pathname: a, search: c } = V(e, { relative: t }), s = a;
  return r !== "/" && (s = a === "/" ? r : L([r, a])), i.createHref({ pathname: s, search: c, hash: n });
}
function X() {
  return u.useContext(ne) != null;
}
function A() {
  return R(
    X(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), u.useContext(ne).location;
}
var be = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function Se(e) {
  u.useContext(I).static || u.useLayoutEffect(e);
}
function ot() {
  let { isDataRoute: e } = u.useContext(T);
  return e ? xt() : ut();
}
function ut() {
  R(
    X(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = u.useContext(_), { basename: t, navigator: r } = u.useContext(I), { matches: i } = u.useContext(T), { pathname: n } = A(), a = JSON.stringify(xe(i)), c = u.useRef(!1);
  return Se(() => {
    c.current = !0;
  }), u.useCallback(
    (l, o = {}) => {
      if ($(c.current, be), !c.current) return;
      if (typeof l == "number") {
        r.go(l);
        return;
      }
      let d = Ce(
        l,
        JSON.parse(a),
        n,
        o.relative === "path"
      );
      e == null && t !== "/" && (d.pathname = d.pathname === "/" ? t : L([t, d.pathname])), (o.replace ? r.replace : r.push)(
        d,
        o.state,
        o
      );
    },
    [
      t,
      r,
      a,
      n,
      e
    ]
  );
}
u.createContext(null);
function V(e, { relative: t } = {}) {
  let { matches: r } = u.useContext(T), { pathname: i } = A(), n = JSON.stringify(xe(r));
  return u.useMemo(
    () => Ce(
      e,
      JSON.parse(n),
      i,
      t === "path"
    ),
    [e, n, i, t]
  );
}
function st(e, t, r, i) {
  R(
    X(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: n, static: a } = u.useContext(I), { matches: c } = u.useContext(T), s = c[c.length - 1], l = s ? s.params : {}, o = s ? s.pathname : "/", d = s ? s.pathnameBase : "/", m = s && s.route;
  {
    let v = m && m.path || "";
    Pe(
      o,
      !m || v.endsWith("*") || v.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${o}" (under <Route path="${v}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${v}"> to <Route path="${v === "/" ? "*" : `${v}/*`}">.`
    );
  }
  let f = A(), g;
  g = f;
  let h = g.pathname || "/", w = h;
  if (d !== "/") {
    let v = d.replace(/^\//, "").split("/");
    w = "/" + h.replace(/^\//, "").split("/").slice(v.length).join("/");
  }
  let y = !a && r && r.matches && r.matches.length > 0 ? r.matches : ye(e, { pathname: w });
  return $(
    m || y != null,
    `No routes matched location "${g.pathname}${g.search}${g.hash}" `
  ), $(
    y == null || y[y.length - 1].route.element !== void 0 || y[y.length - 1].route.Component !== void 0 || y[y.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${g.pathname}${g.search}${g.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  ), mt(
    y && y.map(
      (v) => Object.assign({}, v, {
        params: Object.assign({}, l, v.params),
        pathname: L([
          d,
          // Re-encode pathnames that were decoded inside matchRoutes
          n.encodeLocation ? n.encodeLocation(v.pathname).pathname : v.pathname
        ]),
        pathnameBase: v.pathnameBase === "/" ? d : L([
          d,
          // Re-encode pathnames that were decoded inside matchRoutes
          n.encodeLocation ? n.encodeLocation(v.pathnameBase).pathname : v.pathnameBase
        ])
      })
    ),
    c,
    r,
    i
  );
}
function ct() {
  let e = wt(), t = rt(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), r = e instanceof Error ? e.stack : null, i = "rgba(200,200,200, 0.5)", n = { padding: "0.5rem", backgroundColor: i }, a = { padding: "2px 4px", backgroundColor: i }, c = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), c = /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ u.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ u.createElement("code", { style: a }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ u.createElement("code", { style: a }, "errorElement"), " prop on your route.")), /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ u.createElement("h3", { style: { fontStyle: "italic" } }, t), r ? /* @__PURE__ */ u.createElement("pre", { style: n }, r) : null, c);
}
var ft = /* @__PURE__ */ u.createElement(ct, null), dt = class extends u.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ u.createElement(T.Provider, { value: this.props.routeContext }, /* @__PURE__ */ u.createElement(
      ae.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function ht({ routeContext: e, match: t, children: r }) {
  let i = u.useContext(_);
  return i && i.static && i.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (i.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ u.createElement(T.Provider, { value: e }, r);
}
function mt(e, t = [], r = null, i = null) {
  if (e == null) {
    if (!r)
      return null;
    if (r.errors)
      e = r.matches;
    else if (t.length === 0 && !r.initialized && r.matches.length > 0)
      e = r.matches;
    else
      return null;
  }
  let n = e, a = r == null ? void 0 : r.errors;
  if (a != null) {
    let l = n.findIndex(
      (o) => o.route.id && (a == null ? void 0 : a[o.route.id]) !== void 0
    );
    R(
      l >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        a
      ).join(",")}`
    ), n = n.slice(
      0,
      Math.min(n.length, l + 1)
    );
  }
  let c = !1, s = -1;
  if (r)
    for (let l = 0; l < n.length; l++) {
      let o = n[l];
      if ((o.route.HydrateFallback || o.route.hydrateFallbackElement) && (s = l), o.route.id) {
        let { loaderData: d, errors: m } = r, f = o.route.loader && !d.hasOwnProperty(o.route.id) && (!m || m[o.route.id] === void 0);
        if (o.route.lazy || f) {
          c = !0, s >= 0 ? n = n.slice(0, s + 1) : n = [n[0]];
          break;
        }
      }
    }
  return n.reduceRight((l, o, d) => {
    let m, f = !1, g = null, h = null;
    r && (m = a && o.route.id ? a[o.route.id] : void 0, g = o.route.errorElement || ft, c && (s < 0 && d === 0 ? (Pe(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), f = !0, h = null) : s === d && (f = !0, h = o.route.hydrateFallbackElement || null)));
    let w = t.concat(n.slice(0, d + 1)), y = () => {
      let p;
      return m ? p = g : f ? p = h : o.route.Component ? p = /* @__PURE__ */ u.createElement(o.route.Component, null) : o.route.element ? p = o.route.element : p = l, /* @__PURE__ */ u.createElement(
        ht,
        {
          match: o,
          routeContext: {
            outlet: l,
            matches: w,
            isDataRoute: r != null
          },
          children: p
        }
      );
    };
    return r && (o.route.ErrorBoundary || o.route.errorElement || d === 0) ? /* @__PURE__ */ u.createElement(
      dt,
      {
        location: r.location,
        revalidation: r.revalidation,
        component: g,
        error: m,
        children: y(),
        routeContext: { outlet: null, matches: w, isDataRoute: !0 }
      }
    ) : y();
  }, null);
}
function ie(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function pt(e) {
  let t = u.useContext(_);
  return R(t, ie(e)), t;
}
function gt(e) {
  let t = u.useContext(G);
  return R(t, ie(e)), t;
}
function yt(e) {
  let t = u.useContext(T);
  return R(t, ie(e)), t;
}
function le(e) {
  let t = yt(e), r = t.matches[t.matches.length - 1];
  return R(
    r.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), r.route.id;
}
function vt() {
  return le(
    "useRouteId"
    /* UseRouteId */
  );
}
function wt() {
  var i;
  let e = u.useContext(ae), t = gt(
    "useRouteError"
    /* UseRouteError */
  ), r = le(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (i = t.errors) == null ? void 0 : i[r];
}
function xt() {
  let { router: e } = pt(
    "useNavigate"
    /* UseNavigateStable */
  ), t = le(
    "useNavigate"
    /* UseNavigateStable */
  ), r = u.useRef(!1);
  return Se(() => {
    r.current = !0;
  }), u.useCallback(
    (c, ...s) => U(this, [c, ...s], function* (n, a = {}) {
      $(r.current, be), r.current && (typeof n == "number" ? e.navigate(n) : yield e.navigate(n, b({ fromRouteId: t }, a)));
    }),
    [e, t]
  );
}
var pe = {};
function Pe(e, t, r) {
  !t && !pe[e] && (pe[e] = !0, $(!1, r));
}
u.memo(Ct);
function Ct({
  routes: e,
  future: t,
  state: r
}) {
  return st(e, void 0, r, t);
}
var K = "get", q = "application/x-www-form-urlencoded";
function Q(e) {
  return e != null && typeof e.tagName == "string";
}
function Et(e) {
  return Q(e) && e.tagName.toLowerCase() === "button";
}
function Rt(e) {
  return Q(e) && e.tagName.toLowerCase() === "form";
}
function bt(e) {
  return Q(e) && e.tagName.toLowerCase() === "input";
}
function St(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Pt(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !St(e);
}
var J = null;
function kt() {
  if (J === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), J = !1;
    } catch (e) {
      J = !0;
    }
  return J;
}
var Lt = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function ee(e) {
  return e != null && !Lt.has(e) ? ($(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${q}"`
  ), null) : e;
}
function $t(e, t) {
  let r, i, n, a, c;
  if (Rt(e)) {
    let s = e.getAttribute("action");
    i = s ? D(s, t) : null, r = e.getAttribute("method") || K, n = ee(e.getAttribute("enctype")) || q, a = new FormData(e);
  } else if (Et(e) || bt(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (i = l ? D(l, t) : null, r = e.getAttribute("formmethod") || s.getAttribute("method") || K, n = ee(e.getAttribute("formenctype")) || ee(s.getAttribute("enctype")) || q, a = new FormData(s, e), !kt()) {
      let { name: o, type: d, value: m } = e;
      if (d === "image") {
        let f = o ? `${o}.` : "";
        a.append(`${f}x`, "0"), a.append(`${f}y`, "0");
      } else o && a.append(o, m);
    }
  } else {
    if (Q(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    r = K, i = null, n = q, c = e;
  }
  return a && n === "text/plain" && (c = a, a = void 0), { action: i, method: r.toLowerCase(), encType: n, formData: a, body: c };
}
function oe(e, t) {
  if (e === !1 || e === null || typeof e == "undefined")
    throw new Error(t);
}
function It(e, t) {
  return U(this, null, function* () {
    if (e.id in t)
      return t[e.id];
    try {
      let r = yield import(
        /* @vite-ignore */
        /* webpackIgnore: true */
        e.module
      );
      return t[e.id] = r, r;
    } catch (r) {
      return console.error(
        `Error loading route module \`${e.module}\`, reloading page...`
      ), console.error(r), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
      });
    }
  });
}
function Tt(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
function Dt(e, t, r) {
  return U(this, null, function* () {
    let i = yield Promise.all(
      e.map((n) => U(this, null, function* () {
        let a = t.routes[n.route.id];
        if (a) {
          let c = yield It(a, r);
          return c.links ? c.links() : [];
        }
        return [];
      }))
    );
    return Mt(
      i.flat(1).filter(Tt).filter((n) => n.rel === "stylesheet" || n.rel === "preload").map(
        (n) => n.rel === "stylesheet" ? B(b({}, n), { rel: "prefetch", as: "style" }) : B(b({}, n), { rel: "prefetch" })
      )
    );
  });
}
function ge(e, t, r, i, n, a) {
  let c = (l, o) => r[o] ? l.route.id !== r[o].route.id : !0, s = (l, o) => {
    var d;
    return (
      // param change, /users/123 -> /users/456
      r[o].pathname !== l.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((d = r[o].route.path) == null ? void 0 : d.endsWith("*")) && r[o].params["*"] !== l.params["*"]
    );
  };
  return a === "assets" ? t.filter(
    (l, o) => c(l, o) || s(l, o)
  ) : a === "data" ? t.filter((l, o) => {
    var m;
    let d = i.routes[l.route.id];
    if (!d || !d.hasLoader)
      return !1;
    if (c(l, o) || s(l, o))
      return !0;
    if (l.route.shouldRevalidate) {
      let f = l.route.shouldRevalidate({
        currentUrl: new URL(
          n.pathname + n.search + n.hash,
          window.origin
        ),
        currentParams: ((m = r[0]) == null ? void 0 : m.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: l.params,
        defaultShouldRevalidate: !0
      });
      if (typeof f == "boolean")
        return f;
    }
    return !0;
  }) : [];
}
function Ft(e, t, { includeHydrateFallback: r } = {}) {
  return Nt(
    e.map((i) => {
      let n = t.routes[i.route.id];
      if (!n) return [];
      let a = [n.module];
      return n.clientActionModule && (a = a.concat(n.clientActionModule)), n.clientLoaderModule && (a = a.concat(n.clientLoaderModule)), r && n.hydrateFallbackModule && (a = a.concat(n.hydrateFallbackModule)), n.imports && (a = a.concat(n.imports)), a;
    }).flat(1)
  );
}
function Nt(e) {
  return [...new Set(e)];
}
function At(e) {
  let t = {}, r = Object.keys(e).sort();
  for (let i of r)
    t[i] = e[i];
  return t;
}
function Mt(e, t) {
  let r = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((i, n) => {
    let a = JSON.stringify(At(n));
    return r.has(a) || (r.add(a), i.push({ key: a, link: n })), i;
  }, []);
}
function Ot(e, t) {
  let r = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window == "undefined" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return r.pathname === "/" ? r.pathname = "_root.data" : t && D(r.pathname, t) === "/" ? r.pathname = `${t.replace(/\/$/, "")}/_root.data` : r.pathname = `${r.pathname.replace(/\/$/, "")}.data`, r;
}
function ke() {
  let e = u.useContext(_);
  return oe(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function Bt() {
  let e = u.useContext(G);
  return oe(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var ue = u.createContext(void 0);
ue.displayName = "FrameworkContext";
function Le() {
  let e = u.useContext(ue);
  return oe(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function Wt(e, t) {
  let r = u.useContext(ue), [i, n] = u.useState(!1), [a, c] = u.useState(!1), { onFocus: s, onBlur: l, onMouseEnter: o, onMouseLeave: d, onTouchStart: m } = t, f = u.useRef(null);
  u.useEffect(() => {
    if (e === "render" && c(!0), e === "viewport") {
      let w = (p) => {
        p.forEach((v) => {
          c(v.isIntersecting);
        });
      }, y = new IntersectionObserver(w, { threshold: 0.5 });
      return f.current && y.observe(f.current), () => {
        y.disconnect();
      };
    }
  }, [e]), u.useEffect(() => {
    if (i) {
      let w = setTimeout(() => {
        c(!0);
      }, 100);
      return () => {
        clearTimeout(w);
      };
    }
  }, [i]);
  let g = () => {
    n(!0);
  }, h = () => {
    n(!1), c(!1);
  };
  return r ? e !== "intent" ? [a, f, {}] : [
    a,
    f,
    {
      onFocus: z(s, g),
      onBlur: z(l, h),
      onMouseEnter: z(o, g),
      onMouseLeave: z(d, h),
      onTouchStart: z(m, g)
    }
  ] : [!1, f, {}];
}
function z(e, t) {
  return (r) => {
    e && e(r), r.defaultPrevented || t(r);
  };
}
function Ut(r) {
  var i = r, {
    page: e
  } = i, t = W(i, [
    "page"
  ]);
  let { router: n } = ke(), a = u.useMemo(
    () => ye(n.routes, e, n.basename),
    [n.routes, e, n.basename]
  );
  return a ? /* @__PURE__ */ u.createElement(Ht, b({ page: e, matches: a }, t)) : null;
}
function _t(e) {
  let { manifest: t, routeModules: r } = Le(), [i, n] = u.useState([]);
  return u.useEffect(() => {
    let a = !1;
    return Dt(e, t, r).then(
      (c) => {
        a || n(c);
      }
    ), () => {
      a = !0;
    };
  }, [e, t, r]), i;
}
function Ht(i) {
  var n = i, {
    page: e,
    matches: t
  } = n, r = W(n, [
    "page",
    "matches"
  ]);
  let a = A(), { manifest: c, routeModules: s } = Le(), { basename: l } = ke(), { loaderData: o, matches: d } = Bt(), m = u.useMemo(
    () => ge(
      e,
      t,
      d,
      c,
      a,
      "data"
    ),
    [e, t, d, c, a]
  ), f = u.useMemo(
    () => ge(
      e,
      t,
      d,
      c,
      a,
      "assets"
    ),
    [e, t, d, c, a]
  ), g = u.useMemo(() => {
    if (e === a.pathname + a.search + a.hash)
      return [];
    let y = /* @__PURE__ */ new Set(), p = !1;
    if (t.forEach((x) => {
      var C;
      let E = c.routes[x.route.id];
      !E || !E.hasLoader || (!m.some((S) => S.route.id === x.route.id) && x.route.id in o && ((C = s[x.route.id]) != null && C.shouldRevalidate) || E.hasClientLoader ? p = !0 : y.add(x.route.id));
    }), y.size === 0)
      return [];
    let v = Ot(e, l);
    return p && y.size > 0 && v.searchParams.set(
      "_routes",
      t.filter((x) => y.has(x.route.id)).map((x) => x.route.id).join(",")
    ), [v.pathname + v.search];
  }, [
    l,
    o,
    a,
    c,
    m,
    t,
    e,
    s
  ]), h = u.useMemo(
    () => Ft(f, c),
    [f, c]
  ), w = _t(f);
  return /* @__PURE__ */ u.createElement(u.Fragment, null, g.map((y) => /* @__PURE__ */ u.createElement("link", b({ key: y, rel: "prefetch", as: "fetch", href: y }, r))), h.map((y) => /* @__PURE__ */ u.createElement("link", b({ key: y, rel: "modulepreload", href: y }, r))), w.map(({ key: y, link: p }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ u.createElement("link", b({ key: y }, p))
  )));
}
function zt(...e) {
  return (t) => {
    e.forEach((r) => {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}
var $e = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined";
try {
  $e && (window.__reactRouterVersion = "7.5.0");
} catch (e) {
}
var Ie = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Te = u.forwardRef(
  function(h, g) {
    var w = h, {
      onClick: t,
      discover: r = "render",
      prefetch: i = "none",
      relative: n,
      reloadDocument: a,
      replace: c,
      state: s,
      target: l,
      to: o,
      preventScrollReset: d,
      viewTransition: m
    } = w, f = W(w, [
      "onClick",
      "discover",
      "prefetch",
      "relative",
      "reloadDocument",
      "replace",
      "state",
      "target",
      "to",
      "preventScrollReset",
      "viewTransition"
    ]);
    let { basename: y } = u.useContext(I), p = typeof o == "string" && Ie.test(o), v, x = !1;
    if (typeof o == "string" && p && (v = o, $e))
      try {
        let P = new URL(window.location.href), O = o.startsWith("//") ? new URL(P.protocol + o) : new URL(o), se = D(O.pathname, y);
        O.origin === P.origin && se != null ? o = se + O.search + O.hash : x = !0;
      } catch (P) {
        $(
          !1,
          `<Link to="${o}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let E = lt(o, { relative: n }), [C, S, k] = Wt(
      i,
      f
    ), F = Kt(o, {
      replace: c,
      state: s,
      target: l,
      preventScrollReset: d,
      relative: n,
      viewTransition: m
    });
    function N(P) {
      t && t(P), P.defaultPrevented || F(P);
    }
    let M = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ u.createElement(
        "a",
        B(b(b({}, f), k), {
          href: v || E,
          onClick: x || a ? t : N,
          ref: zt(g, S),
          target: l,
          "data-discover": !p && r === "render" ? "true" : void 0
        })
      )
    );
    return C && !p ? /* @__PURE__ */ u.createElement(u.Fragment, null, M, /* @__PURE__ */ u.createElement(Ut, { page: E })) : M;
  }
);
Te.displayName = "Link";
var Vt = u.forwardRef(
  function(m, d) {
    var f = m, {
      "aria-current": t = "page",
      caseSensitive: r = !1,
      className: i = "",
      end: n = !1,
      style: a,
      to: c,
      viewTransition: s,
      children: l
    } = f, o = W(f, [
      "aria-current",
      "caseSensitive",
      "className",
      "end",
      "style",
      "to",
      "viewTransition",
      "children"
    ]);
    let g = V(c, { relative: o.relative }), h = A(), w = u.useContext(G), { navigator: y, basename: p } = u.useContext(I), v = w != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    Qt(g) && s === !0, x = y.encodeLocation ? y.encodeLocation(g).pathname : g.pathname, E = h.pathname, C = w && w.navigation && w.navigation.location ? w.navigation.location.pathname : null;
    r || (E = E.toLowerCase(), C = C ? C.toLowerCase() : null, x = x.toLowerCase()), C && p && (C = D(C, p) || C);
    const S = x !== "/" && x.endsWith("/") ? x.length - 1 : x.length;
    let k = E === x || !n && E.startsWith(x) && E.charAt(S) === "/", F = C != null && (C === x || !n && C.startsWith(x) && C.charAt(x.length) === "/"), N = {
      isActive: k,
      isPending: F,
      isTransitioning: v
    }, M = k ? t : void 0, P;
    typeof i == "function" ? P = i(N) : P = [
      i,
      k ? "active" : null,
      F ? "pending" : null,
      v ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let O = typeof a == "function" ? a(N) : a;
    return /* @__PURE__ */ u.createElement(
      Te,
      B(b({}, o), {
        "aria-current": M,
        className: P,
        ref: d,
        style: O,
        to: c,
        viewTransition: s
      }),
      typeof l == "function" ? l(N) : l
    );
  }
);
Vt.displayName = "NavLink";
var jt = u.forwardRef(
  (h, g) => {
    var w = h, {
      discover: e = "render",
      fetcherKey: t,
      navigate: r,
      reloadDocument: i,
      replace: n,
      state: a,
      method: c = K,
      action: s,
      onSubmit: l,
      relative: o,
      preventScrollReset: d,
      viewTransition: m
    } = w, f = W(w, [
      "discover",
      "fetcherKey",
      "navigate",
      "reloadDocument",
      "replace",
      "state",
      "method",
      "action",
      "onSubmit",
      "relative",
      "preventScrollReset",
      "viewTransition"
    ]);
    let y = Gt(), p = Xt(s, { relative: o }), v = c.toLowerCase() === "get" ? "get" : "post", x = typeof s == "string" && Ie.test(s), E = (C) => {
      if (l && l(C), C.defaultPrevented) return;
      C.preventDefault();
      let S = C.nativeEvent.submitter, k = (S == null ? void 0 : S.getAttribute("formmethod")) || c;
      y(S || C.currentTarget, {
        fetcherKey: t,
        method: k,
        navigate: r,
        replace: n,
        state: a,
        relative: o,
        preventScrollReset: d,
        viewTransition: m
      });
    };
    return /* @__PURE__ */ u.createElement(
      "form",
      B(b({
        ref: g,
        method: v,
        action: p,
        onSubmit: i ? l : E
      }, f), {
        "data-discover": !x && e === "render" ? "true" : void 0
      })
    );
  }
);
jt.displayName = "Form";
function Jt(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function De(e) {
  let t = u.useContext(_);
  return R(t, Jt(e)), t;
}
function Kt(e, {
  target: t,
  replace: r,
  state: i,
  preventScrollReset: n,
  relative: a,
  viewTransition: c
} = {}) {
  let s = ot(), l = A(), o = V(e, { relative: a });
  return u.useCallback(
    (d) => {
      if (Pt(d, t)) {
        d.preventDefault();
        let m = r !== void 0 ? r : te(l) === te(o);
        s(e, {
          replace: m,
          state: i,
          preventScrollReset: n,
          relative: a,
          viewTransition: c
        });
      }
    },
    [
      l,
      s,
      o,
      r,
      i,
      t,
      e,
      n,
      a,
      c
    ]
  );
}
var qt = 0, Yt = () => `__${String(++qt)}__`;
function Gt() {
  let { router: e } = De(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = u.useContext(I), r = vt();
  return u.useCallback(
    (a, ...c) => U(this, [a, ...c], function* (i, n = {}) {
      let { action: s, method: l, encType: o, formData: d, body: m } = $t(
        i,
        t
      );
      if (n.navigate === !1) {
        let f = n.fetcherKey || Yt();
        yield e.fetch(f, r, n.action || s, {
          preventScrollReset: n.preventScrollReset,
          formData: d,
          body: m,
          formMethod: n.method || l,
          formEncType: n.encType || o,
          flushSync: n.flushSync
        });
      } else
        yield e.navigate(n.action || s, {
          preventScrollReset: n.preventScrollReset,
          formData: d,
          body: m,
          formMethod: n.method || l,
          formEncType: n.encType || o,
          replace: n.replace,
          state: n.state,
          fromRouteId: r,
          flushSync: n.flushSync,
          viewTransition: n.viewTransition
        });
    }),
    [e, t, r]
  );
}
function Xt(e, { relative: t } = {}) {
  let { basename: r } = u.useContext(I), i = u.useContext(T);
  R(i, "useFormAction must be used inside a RouteContext");
  let [n] = i.matches.slice(-1), a = b({}, V(e || ".", { relative: t })), c = A();
  if (e == null) {
    a.search = c.search;
    let s = new URLSearchParams(a.search), l = s.getAll("index");
    if (l.some((d) => d === "")) {
      s.delete("index"), l.filter((m) => m).forEach((m) => s.append("index", m));
      let d = s.toString();
      a.search = d ? `?${d}` : "";
    }
  }
  return (!e || e === ".") && n.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), r !== "/" && (a.pathname = a.pathname === "/" ? r : L([r, a.pathname])), te(a);
}
function Qt(e, t = {}) {
  let r = u.useContext(Re);
  R(
    r != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: i } = De(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), n = V(e, { relative: t.relative });
  if (!r.isTransitioning)
    return !1;
  let a = D(r.currentLocation.pathname, i) || r.currentLocation.pathname, c = D(r.nextLocation.pathname, i) || r.nextLocation.pathname;
  return Y(n.pathname, c) != null || Y(n.pathname, a) != null;
}
new TextEncoder();
export {
  Te as L,
  ot as a,
  A as u
};
